
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.75.25H7v20h3.75v-20zM4.5 10.25H.75v10H4.5v-10zM13.25 4H17v16.25h-3.75V4zM23.25 7.75H19.5v12.5h3.75V7.75z","fill":"#8D16C1"}})])
          )
        }
      }
    